'use strict';

const RestUtils = require('utils/RestUtils'),
    Constants = require('constants/AppConstants'),
    Security = require('./Security').auth,
    apiAppUrl = process.env.URL_API;

const UserServiceImpl = {

    getUsers(onSuccess, onFailure, token, applicantId) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)(JSON.parse(this.response));
            }, function () {
                onFailure.bind(this)(JSON.parse(this.responseText));
            });
        });

        ajax.open('GET', apiAppUrl + '/api/users', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, token || Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, applicantId || Security.getCurrentApplicantId());
        ajax.send();
    },

    fetchUsers(onSuccess, onFailure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)(JSON.parse(this.response));
            }, function () {
                onFailure.bind(this)(JSON.parse(this.responseText));
            });
        });

        ajax.open('GET', apiAppUrl + '/api/users', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    getUsersAccess(onSuccess, onFailure, tokenString, applicantId) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)(JSON.parse(this.response));
            }, function () {
                onFailure.bind(this)(JSON.parse(this.responseText));
            });
        });

        ajax.open('GET', apiAppUrl + '/api/users/permissions', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, tokenString || Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, applicantId || Security.getCurrentApplicantId());
        ajax.send();
    },

    getEmailAlreadyUsed(onSuccess, onFailure, tokenString, applicantId, email) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)(true);
            }, function () {
                onFailure.bind(this)(false);
            });
        });
        
        ajax.open('PUT', apiAppUrl + '/api/users/check', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, tokenString || Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, applicantId || Security.getCurrentApplicantId());
        ajax.send(email);
    },

    updatePermission(userId, permissionId, isEnable, onSuccess, onFailure, token, applicantId) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess();
            }, function () {
                onFailure.bind(this)(JSON.parse(this.responseText).message);
            });
        });

        ajax.open('PUT', apiAppUrl + '/api/users/' + userId + '/permissions/' + permissionId + '?is-enable=' + isEnable, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, token || Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, applicantId || Security.getCurrentApplicantId());
        ajax.send();
    },

    updatePermissions(userId, permissions, isEnable, onSuccess, onFailure, token, applicantId) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess();
            }, function () {
                onFailure.bind(this)(JSON.parse(this.responseText).message);
            });
        });

        ajax.open('PUT', apiAppUrl + '/api/users/' + userId + '/permissions');
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, token || Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, applicantId || Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(permissions));
    },

    updateUser(user, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('PUT', apiAppUrl + '/api/users', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send(JSON.stringify(user));
    },

    createUser(user, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('POST', apiAppUrl + '/api/users', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send(JSON.stringify(user));
    },

    changeUser(user, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('PUT', apiAppUrl + '/api/users', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send(JSON.stringify(user));
    },

    deleteUser(userId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/api/users/' + userId, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    }

};

module.exports = UserServiceImpl;



/** WEBPACK FOOTER **
 ** ./src/services/UserServiceImpl.js
 **/